/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';
import type { TableTdSignature } from 'walden-fast/components/table/td';
import type { TableSpacing } from '..';

export interface TableTrSignature {
  // The arguments accepted by the component
  Args: {
    isDisabled?: boolean;
    spacing?: TableSpacing;
    bordered?: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [
      {
        Td: ComponentLike<TableTdSignature>;
      },
    ];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLTableRowElement;
}

export default templateOnly<TableTrSignature>();
